













































































import { dashboardService } from "@/services/dash";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { reservationService } from "@/services/reservation";
import moment from "moment";
import { Reservation, Team } from "@/swagger/models";
import { User } from "@/swagger/models/user";
import alert from "@/components/misc/alert.vue";

@Component({
    name: "present-users",
    components: { alert },
})
export default class PresentUsers extends Vue {
    @Prop({ required: true })
    customerId: number;

    reservations: Reservation[] = [];

    officeId: number | null = null;
    query: string = "";

    updateInterval: number = null;

    async created() {
        await this.refreshReservations();

        // Update reservations every 30 seconds
        this.updateInterval = window.setInterval(this.refreshReservations.bind(this), 30000);
    }

    destroyed() {
        clearInterval(this.updateInterval);
    }

    get filteredReservations(): Reservation[] {
        return this.reservations
            .filter((r) => {
                return `${(r.user as User).firstName} ${(r.user as User).lastName}`
                    .toLowerCase()
                    .includes(this.query.toLowerCase());
            })
            .sort((r1, r2) => {
                if (this.userIsEmergencyResponseOfficer(<User>r1.user)) return -1;
                else if (this.userIsEmergencyResponseOfficer(<User>r2.user)) return 1;
                else return 0;
            });
    }

    userIsEmergencyResponseOfficer(user: User) {
        return user.teams.some((t: Team) => t.tags?.includes("bhv"));
    }

    @Watch("customerId")
    @Watch("officeId")
    async refreshReservations() {
        this.reservations.length = 0;
        if (!this.customerId) return;

        this.reservations = await reservationService.getPresentUsers(this.customerId, this.officeId);
    }
}
